import { z } from 'zod';
import { ReferralPatientSchema } from '../ReferralPatientSchema';
import { requiredTrimmedString } from '../../../validation';

export const ReferralAvivaPatientSchema = ReferralPatientSchema.extend({
  // Aviva client reference / policy number
  policyNumber: requiredTrimmedString('Policy number is required'),
});

export type ReferralAvivaPatient = z.infer<typeof ReferralAvivaPatientSchema>;
